<div
  [routerLink]="['clients', client?.id]"
  [queryParams]="{ taxYear: populationRules?.year }"
  title="Back to client populations"
>
  {{ client?.name }}
</div>

@if (clientPopulations?.length > 1) {
<div class="ui inline dropdown" title="Change population">
  <h2 class="text">{{ populationRules?.name }}</h2>
  <i class="chevron down icon"></i>
  <div class="menu">
    @for (_population of clientPopulations; track _population) { @if
    (_population.status !== 99) {
    <div
      (click)="changePopulation(_population)"
      class="item"
      [ngClass]="{ active: _population.name === populationRules?.name }"
    >
      {{ _population.name }}
    </div>
    } }
  </div>
</div>
}

<div id="tax-year">
  <h4>{{ yearLabel }}</h4>
  <h3>{{ populationRules?.year }}</h3>
</div>

<h3 id="ans-count">{{ mandatoryAnsCount }}</h3>
<h4 style="margin:0">{{ "mandatory-answered" | transloco }}</h4>

<div class="secondary-sub-menu ui list">
  @for (category of populationRules.populationClientRules | orderBy: 'order';
  track category) { @if (category.id) {
  <div
    [routerLink]="[]"
    [queryParams]="{ category: category.id, taxYear: populationRules.year }"
    [routerLinkActive]="['active']"
    class="item"
    style="display:flex"
  >
    <div style="flex:1">{{ category?.name }}</div>
    @if (category?.mandatoryFieldCount > 0) {
    <div class="mandatory-field-count">{{ category?.mandatoryFieldCount }}</div>
    }
  </div>
  } } @if (globalFieldsCount > 0) {
  <div
    [routerLink]="[]"
    [routerLinkActive]="['active']"
    [queryParams]="{ category: 'global' }"
    class="item"
    style="margin-top:2em"
  >
    {{ "global-fields" | transloco }} ({{ globalFieldsCount }})
  </div>
  }
</div>
